/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ValidationResults {
    getFixupPrototypeFunction() { return ValidationResults.fixupPrototype; }

    static newInstance(model: Partial<ValidationResults>): ValidationResults {
        let obj = Object.assign(new ValidationResults(), model);
        ValidationResults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ValidationResults>): ValidationResults {
        if (!model) return null;
        return ValidationResults.newInstance(<ValidationResults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ValidationResults) {
        if (!obj) return;

        models.ValidationResults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ValidationResults): boolean {
        Object.setPrototypeOf(obj, ValidationResults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.entries) {
            for (let val of this.entries) {
                models.ValidationResult.fixupPrototype(val);
            }
        }
    }

    entries: Array<models.ValidationResult>;

}
